<script setup lang="ts">
import { Head, Link } from '@inertiajs/vue3'
import { inject, ref } from 'vue'
import { layoutStructure } from '@/Composables/useLayoutStructure'
import PageHeading from "@/Components/Headings/PageHeading.vue"
import { PageHeading as PageHeadingTS } from '@/types/PageHeading'
import Table from '@/Components/Table/Table.vue'
import Icon from '@/Components/Utils/Icon.vue'
import Button from '@/Components/Utils/Button.vue'
import CreateComplaintModal from '@/Components/Master/Complaints/CreateComplaintModal.vue'
import { useFormatTime } from '@/Composables/useFormatTime'

const props = defineProps<{
    pageHead?: PageHeadingTS
    title?: string
    root_active?: string
    data: {}
}>()

const layout = inject('layout', layoutStructure)

const complaintShowRoute = (slug: string) =>
    props.root_active === 'manufacture.complaints.'
        ? route('manufacture.complaints.show', slug)
        : route('layout.complaints.show', slug)

const canSeeOrderLink = (): boolean => {
    if (props.root_active !== 'manufacture.complaints.') return true
    return layout.auth?.role === 'super_admin'
}

const orderShowRoute = (slug: string) =>
    route('layout.orders.show', slug)
const isCreateModalOpen = ref(false)
</script>

<template>
    <Head :title="title" />
    <PageHeading :data="pageHead">
        <template #other>
            <Button
                v-if="['layout', 'super_admin'].includes(layout.auth?.role)"
                @click="isCreateModalOpen = true"
                type="create"
                label="Buat Komplain Baru"
            />
        </template>
    </PageHeading>

    <Table :resource="data" name="default">
        <template #cell(created_at)="{ item }">
            {{ useFormatTime(item.created_at) }}
        </template>

        <template #cell(reference)="{ item }">
            <Link :href="complaintShowRoute(item.slug)" class="primaryLink">
                {{ item.reference }}
            </Link>
        </template>

        <template #cell(order)="{ item }">
            <Link v-if="canSeeOrderLink()" :href="orderShowRoute(item.order?.slug)" class="primaryLink">
                {{ item.order?.reference }}
            </Link>
            <span v-else>{{ item.order?.reference ?? '-' }}</span>
        </template>

        <template #cell(customer)="{ item }">
            {{ item.customer?.name ?? '-' }}
        </template>

        <template #cell(status)="{ item }">
            <div class="flex items-center gap-x-1.5">
                <Icon :data="item.status_icon" />
                <span>{{ item.status_label }}</span>
            </div>
        </template>
    </Table>

    <CreateComplaintModal
        v-if="['layout', 'super_admin'].includes(layout.auth?.role)"
        v-model:visible="isCreateModalOpen"
    />
</template>
